export { default } from './useIntersectionObserver';